import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../components/Table/BasicTable.jsx";
import {
  canlenderFilter,
  columns,
  data,
  filters,
  searchBy,
} from "../../service/OrderService.js";
import { useFetchAll } from "../../custom/FetchApiHook.jsx";
import OrderApi, { foodOrderApi } from "../../apis/order.apis.js";
import OrderModal from "./OrderModal/OrderModal.jsx";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";


const OrderComp = ({ disabledFilters, pagination, handlePagination }) => {
  const [search, setSearch] = useState("")
  const debounceTimeout = useRef(null);
  const currentUser = useSelector((state) => state.store);
  const deliveryBusiness = currentUser?.currentUser?.delivery_business?.name
  const { value, fetchAllData } = useFetchAll(() => OrderApi.getAllOrders(pagination ? pagination : {}, search));
  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedOrder(null);
  }

  const handleCellClick = async (cell, field = "") => {
    if (field === "order_id") {
      if (deliveryBusiness !== "Ecommerce") {}
      setSelectedOrder(cell);
      setIsOrderDetail(true);
    }
    if (field.vendor_action) {
      const payload = {
        orderId: cell._id,
        vendor_action: field.vendor_action
      }
      try {
        const res = await OrderApi.updateOrders(payload)
        toast.success(`Order ${res?.data?.data?.delivery_status}`)

      } catch (error) {
        console.log(error);
      } finally {
        fetchAllData();
        setIsOrderDetail(false);
        setSelectedOrder(null);
      }
    }

  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1
      }
      handlePagination && handlePagination(data)
    }

  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback((s) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(s);
    }, 1500);
  }, [handleSearch]);


  const handleClearFilter = () => {
    const clearPagination = {
      "page": 1,
      "limit": 5,
      "sortOrder": "desc",
      "filter": {}
    }
    handlePagination && handlePagination({ clearPagination })
  }


  const handleFilter = (name, value) => {
    let data = {}
    if (name === 'search_by') {
      data.sortOrder = value.code
    }
    else {
      const filter = {}
      filter[`${name}`] = value.code ? value.code : value
      data.filter = filter
    }
    handlePagination && handlePagination(data)
  }

  useEffect(() => {
    fetchAllData()
  }, [pagination, search, isOrderDetail]);


  const DataFilter = filters.filter((f) => disabledFilters ? !disabledFilters.includes(f.inputName) : true)
  return (
    <div className="p-1">
      <BasicTable
        columns={columns}
        data={value?.data?.orders}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value.data?.totalPages || 1,
          totalCount: value.data?.totalCount || 1
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        WeekRange={false}
        MonthRange={true}
        canlenderFilter={canlenderFilter}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />

      <OrderModal
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        orderData={selectedOrder}
        pagination={pagination}
        search={search}
      />

    </div>
  );
};

export default OrderComp;